import React, { FC, memo, useCallback } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { FastField } from 'formik';

import {
  Container,
  Input,
  PriceInput,
  Row,
  InputContainer,
  Label,
  Select,
  ActionButton,
  DraggableIcon,
} from './styles';
import { Props } from './types';

const Item: FC<Props> = ({
  index,
  id,
  remove,
  isProcessing,
  status,
  state,
  brandId,
  isUpdatingStatus,
}) => {
  const handleRemove = useCallback(() => remove(index), [remove, index]);

  return (
    <Draggable draggableId={id} index={index} isDragDisabled={isProcessing}>
      {(provided) => (
        <Container
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {!isProcessing && <DraggableIcon />}
          {/* @ts-ignore */}
          <FastField
            name={`temporalItems.${index}.name`}
            as={Input}
            label="Name"
            disabled={isProcessing}
          />
          <Row>
            {/* @ts-ignore */}
            <FastField
              name={`temporalItems.${index}.price`}
              as={PriceInput}
              label="Price"
              disabled={isProcessing}
            />
            <InputContainer>
              <Label>Status</Label>
              <Select
                mode="modifier"
                value={status}
                brandId={brandId}
                itemId={id}
                state={state}
                isUpdatingStatus={isUpdatingStatus}
              />
            </InputContainer>
            <ActionButton
              variant="delete"
              type="button"
              onClick={handleRemove}
              disabled={isProcessing}
            />
          </Row>
        </Container>
      )}
    </Draggable>
  );
};

export default memo(Item);
